import { makeStyles } from "tss-react/mui";

const useSearchDialogStyles = makeStyles()((theme) => ({
  container: {
    height: "300px",
    padding: "8px 16px",
    backgroundColor: theme.palette.surface.light,
  },
  search: {
    padding: "2px 16px 8px 16px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
  },
}));

export default useSearchDialogStyles;
